/* eslint-disable */
import $ from 'jquery';
import '../../../source/javascripts/vendor/admin/js/libs/jquery.qtip/jquery.qtip-1.0.0-rc3.min';
import '../../../source/javascripts/vendor/admin/js/libs/jquery.qtip/jquery.qtip.min.css';
// $('a[rel*=osirase]').fancybox({
//   'width':800,
//   'height':600,
//   'type':"iframe"
// });
// Use the each() method to gain access to each elements attribute
$(document).ready(function() {

  $('a.tipHelp').each(function() {

    $(this).qtip({
      content: {
        text: function(event, api) {
          $.ajax({ url: $(this).attr('rel') })
            .done(function(html) {
              api.set('content.text', html)
            })
            .fail(function(xhr, status, error) {
              api.set('content.text', status + ': ' + error)
            })
          return 'Loading...';
        },

        button: 'Close'
      },
      position: {
        effect: false,
        my: 'bottom center',
        at: 'top center'
      },
      show: 'click',
      hide: {
        event: 'unfocus'
      },
      style: {
        classes: 'qtip-light qtip-shadow'
      }
    });


  });

  $('a.tipHelp2').each(function() {
      $(this).qtip(
        {
          content: {
            // Set the text to an image HTML string with the correct src URL to the loading image you want to use
            text: '<img class="throbber" src="/projects/qtip/images/throbber.gif" alt="Loading..." />',
            url: $(this).attr('rel'), // Use the rel attribute of each element for the url to load
            title: {
              text: '' + $(this).text(),
              // Give the tooltip a title using each elements text
              button: 'close' // Show a close link in the title
            }
          },
          position: {
            corner: {
              target: 'bottomMiddle', // Position the tooltip above the link
              tooltip: 'topMiddle'
            },
            adjust: {
              screen: true // Keep the tooltip on-screen at all times
            }
          },
          show: {
            when: 'click',
            solo: true // Only show one tooltip at a time
          },
          hide: 'unfocus',
          style: {
            tip: true, // Apply a speech bubble tip to the tooltip at the designated tooltip corner
            border: {
              width: 0,
              radius: 4
            },
            name: 'cream', // Use the default light style
            width: 570// Set the tooltip width
          }
        })
    });
  }
);



// WEBPACK FOOTER //
// ./es6/admin-common-js/legacy/qtip.js